import { CellType } from "@omegagrid/grid";
import { JobParam, JobStatus, ETLJob, AgentSchedule } from "@reporting/rp-types/jobs";

export type JobStatusExt = JobStatus & {_start: number};

export enum WatcherItemType {
	JOB = 'job',
	AGENT = 'agent'
}

export type WatcherItem = {
	type: WatcherItemType;
	name: string;
	ord_num?: number;
	job?: ETLJob;
	agent?: AgentSchedule;
}

export enum JobStepAction {
    QuitWithSuccess = 1,
    QuitWithFailure = 2,
    GoToNextStep = 3,
    GoToStep = 4
}

export enum JobStepSubsystem {
    TSQL = 'TSQL',
    PowerShell = 'PowerShell'
}

export const JOB_PARAMS: JobParamSpec[] = [
	{ name: 'value_b', type: 'n' },
	{ name: 'value_i', type: 'n' },
	{ name: 'value_f', type: 'n' },
	{ name: 'value_s', type: 't' },
	{ name: 'value_s2', type: 't' },
	{ name: 'value_s3', type: 't' }
];

export type JobParamSpec = {
	name: keyof JobParam;
	type: CellType;
}

export const WEEK_DAYS: { day: number; name: string }[] = [
    { day: 1, name: 'Monday' },
    { day: 2, name: 'Tuesday' },
    { day: 3, name: 'Wednesday' },
    { day: 4, name: 'Thursday' },
    { day: 5, name: 'Friday' },
    { day: 6, name: 'Saturday' },
    { day: 7, name: 'Sunday' },
];
